import React from 'react';
import PropTypes from 'prop-types';
import { FaShuttleVan, FaPlus } from 'react-icons/fa';
import { Button } from 'components/common';

const StarterShuttle = ({ setShowModalShuttle }) => (
  <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-py-12 tw-px-6">
    <span
      className="tw-flex tw-items-center tw-justify-center tw-w-16 tw-h-16 tw-rounded-2xl tw-mb-4 tw-text-white"
      style={{ backgroundImage: 'linear-gradient(135deg, #3b82f6, #2563eb)', boxShadow: '0 8px 20px rgba(37,99,235,0.30)' }}
    >
      <FaShuttleVan size={26} />
    </span>
    <h3 className="tw-text-slate-800 tw-font-semibold tw-text-lg tw-mb-1">Shuttle Booking</h3>
    <p className="tw-text-slate-500 tw-mb-4 tw-max-w-md">Book shuttle transportation for your trip, including company vehicles, car rentals, flights, trains, taxis, and more.</p>
    <Button size="sm" variant="primary" leftIcon={FaPlus} onClick={() => setShowModalShuttle(true)}>Book a shuttle now</Button>
  </div>
);

StarterShuttle.propTypes = {
  setShowModalShuttle: PropTypes.func.isRequired,
};

export default StarterShuttle;
